const amplitudeLogPreffix = "❖ [Amplitude]";

export const shouldUseMock = () => {
  if (
    window.location.host !== "app.onlinezdrav.ru" &&
    window.location.host !== "app.onlinezdrav-test.eltc.ru"
  ) {
    console.warn(
      `${amplitudeLogPreffix} Отладочный режим. Отправка событий отключена.`
    );
    return true;
  }

  return false;
};

const logAmplitudeMethod = (message, ...params) =>
  console.log(`${amplitudeLogPreffix} ${message}`, ...params);

export default {
  init: () => logAmplitudeMethod("Инициализация..."),

  onInit: () => logAmplitudeMethod("Инициализация завершена"),

  logEvent: (event, params = {}) =>
    logAmplitudeMethod("Произошло событие:", `«${event}»\n`, params),

  setUserId: (id) =>
    logAmplitudeMethod("Установлен идентификатор текущего пользователя", id),

  setUserProperties: (props = {}) =>
    logAmplitudeMethod("Добавлены параметры текущего пользователя", props),
};
